if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"clubePublication","remotes":[{"alias":"contractLegacy","name":"contractLegacy","entry":"/contracts-legacy/_next/static/chunks/remoteEntry.js","shareScope":"default"},{"alias":"notification","name":"notification","entry":"/notification/_next/static/chunks/remoteEntry.js","shareScope":"default"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(1995|3732|765|8122|8594)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}